import { GetterTree } from 'vuex'
import RootState from '@/store/RootState'
import LandlordState from "@/store/modules/landlord/LandlordState"

export const getters: GetterTree<LandlordState, RootState> = {
  landlord (state) {
    return state.landlord
  }
}
